<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe A (Domicile)</label>
      </div>
      <select v-model="dataForm.equipe_a_id"
              class="custom-select"
              name="match_equipe_a">
        <option :value="match.equipe_a_id">
          {{ equipes ?
            (equipes.filter((equipe) => equipe.equipe_id === match.equipe_a_id)[0].nom) :
            'Choisissez une equipe...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="equipe.equipe_id"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Equipe B (Extérieur)</label>
      </div>
      <select v-model="dataForm.equipe_b_id"
              class="custom-select"
              name="match_equipe_b">
        <option :value="match.equipe_b_id">
          {{ equipes ?
            (equipes.filter((equipe) => equipe.equipe_id === match.equipe_b_id)[0].nom) :
            'Choisissez une equipe...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="equipe.equipe_id"
                :value="equipe.equipe_id"
                v-for="equipe in equipes">
          {{ equipe.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date et Temps de rencontre</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.date_rencontre"
             class="form-control"
             name="match_date_rencontre"
             type="date">
      <input v-model="dataForm.temps_rencontre"
             class="form-control"
             name="match_temps_rencontre"
             type="time">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Terrain</label>
      </div>
      <select v-model="dataForm.terrain_id"
              class="custom-select"
              name="match_terrain">
        <option :value="match.terrain_id">
          {{ terrains ?
            (terrains.filter((match_non_joue) => match_non_joue.terrain_id === match.terrain_id)[0].nom) :
            'Choisissez un terrain...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="terrain.terrain_id"
                :value="terrain.terrain_id"
                v-for="terrain in terrains">
          {{ terrain.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Arbitre Principal</label>
      </div>
      <select v-model="dataForm.arbitre_principal_id"
              class="custom-select"
              name="match_arbitre_principal">
        <option :value="match.arbitre_principal_id">
          {{ (arbitre_principal) ? (
                arbitre_principal.prenom.charAt(0).toUpperCase() + arbitre_principal.prenom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.postnom.charAt(0).toUpperCase() + arbitre_principal.postnom.slice(1).toLowerCase() + ' ' +
                arbitre_principal.nom.charAt(0).toUpperCase() + arbitre_principal.nom.slice(1).toLowerCase() + ' '
                ) : 'Choisissez un arbitre principal...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Assistant 1</label>
      </div>
      <select v-model="dataForm.arbitre_assistant_1_id"
              class="custom-select"
              name="match_arbitre_assistant_1">
        <option :value="match.arbitre_assistant_1_id">
          {{ (arbitre_assistant_1) ? (
            arbitre_assistant_1.prenom.charAt(0).toUpperCase() + arbitre_assistant_1.prenom.slice(1).toLowerCase() + ' ' +
            arbitre_assistant_1.postnom.charAt(0).toUpperCase() + arbitre_assistant_1.postnom.slice(1).toLowerCase() + ' ' +
            arbitre_assistant_1.nom.charAt(0).toUpperCase() + arbitre_assistant_1.nom.slice(1).toLowerCase() + ' '
        ) : 'Choisissez un premier arbitre assistant ...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Assistant 2</label>
      </div>
      <select v-model="dataForm.arbitre_assistant_2_id"
              class="custom-select"
              name="match_arbitre_assistant_2">
        <option :value="match.arbitre_assistant_2_id">
          {{ (arbitre_assistant_2) ? (
            arbitre_assistant_2.prenom.charAt(0).toUpperCase() + arbitre_assistant_2.prenom.slice(1).toLowerCase() + ' ' +
            arbitre_assistant_2.postnom.charAt(0).toUpperCase() + arbitre_assistant_2.postnom.slice(1).toLowerCase() + ' ' +
            arbitre_assistant_2.nom.charAt(0).toUpperCase() + arbitre_assistant_2.nom.slice(1).toLowerCase() + ' '
        ) : 'Choisissez un deuxième arbitre assistant ...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Arbitre Commissaire</label>
      </div>
      <select v-model="dataForm.arbitre_commissaire_id"
              class="custom-select"
              name="match_arbitre_commissaire">
        <option :value="match.arbitre_commissaire_id">
          {{ (arbitre_commissaire) ? (
            arbitre_commissaire.prenom.charAt(0).toUpperCase() + arbitre_commissaire.prenom.slice(1).toLowerCase() + ' ' +
            arbitre_commissaire.postnom.charAt(0).toUpperCase() + arbitre_commissaire.postnom.slice(1).toLowerCase() + ' ' +
            arbitre_commissaire.nom.charAt(0).toUpperCase() + arbitre_commissaire.nom.slice(1).toLowerCase() + ' '
        ) : 'Choisissez un deuxième arbitre assistant ...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="arbitre.arbitre_id"
                :value="arbitre.arbitre_id"
                v-for="arbitre in arbitres">
          {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
          {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
          {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Saison</label>
      </div>
      <select v-model="dataForm.saison_id"
              class="custom-select"
              name="match_saison">
        <option :key="saison.saison_id"
                :value="saison.saison_id"
                v-for="saison in saisons">
          {{ saison.annee_debut }} - {{ saison.annee_fin  }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Championnat</label>
      </div>
      <select v-model="dataForm.championnat_id"
              class="custom-select"
              name="match_championnat">
        <option :value="match.championnat_id">
          {{ championnats ?
            (championnats.filter((championnat) => championnat.championnat_id === match.championnat_id)[0].nom) :
            'Choisissez un championnat...' }}
        </option>
        <option value="">-------------------------------------</option>
        <option :key="championnat.championnat_id.slice(5,15)"
                :value="championnat.championnat_id"
                v-for="championnat in championnats">
          {{ championnat.nom }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Phase</label>
      </div>
      <select v-model="dataForm.phase"
              class="custom-select"
              name="match_phase">
        <option :value="match.phase">
          {{ match.phase }}
        </option>
        <option value="">-------------------------------------</option>
        <option value="aller">Aller</option>
        <option value="retour">Retour</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Journée</label>
      </div>
      <input v-model="dataForm.journee"
             class="form-control"
             name="match_journee"
             type="number">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Update",
  props: {
    match: {
      type: Object
    }
  },
  data() {
    return {
      equipes: null,
      terrains: null,
      arbitres: null,
      saisons: null,
      championnats: null,
      arbitre_principal: null,
      arbitre_assistant_1: null,
      arbitre_assistant_2: null,
      arbitre_commissaire: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        match_id: '',
        equipe_a_id: '',
        equipe_b_id: '',
        date_rencontre: '',
        temps_rencontre: '',
        terrain_id: '',
        arbitre_principal_id: '',
        arbitre_assistant_1_id: '',
        arbitre_assistant_2_id: '',
        arbitre_commissaire_id: '',
        saison_id: '',
        championnat_id: '',
        phase: '',
        journee: '',
        table: 'matchs_non_joues',
        table_id: this.match.match_non_joue_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
    ]),
    onSubmit() {
      this.resetDefaultValues()
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Match modifié avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification du match !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification du match !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.match_id === '')
        this.dataForm.match_id = this.match.match_id
      if(this.dataForm.equipe_a_id === '')
        this.dataForm.equipe_a_id = this.match.equipe_a_id
      if(this.dataForm.equipe_b_id === '')
        this.dataForm.equipe_b_id = this.match.equipe_b_id
      if(this.dataForm.date_rencontre === '')
        this.dataForm.date_rencontre = this.match.date_rencontre
      if(this.dataForm.temps_rencontre === '')
        this.dataForm.temps_rencontre = this.match.temps_rencontre
      if(this.dataForm.terrain_id === '')
        this.dataForm.terrain_id = this.match.terrain_id
      if(this.dataForm.arbitre_principal_id === '')
        this.dataForm.arbitre_principal_id = this.match.arbitre_principal_id
      if(this.dataForm.arbitre_assistant_1_id === '')
        this.dataForm.arbitre_assistant_1_id = this.match.arbitre_assistant_1_id
      if(this.dataForm.arbitre_assistant_2_id === '')
        this.dataForm.arbitre_assistant_2_id = this.match.arbitre_assistant_2_id
      if(this.dataForm.arbitre_commissaire_id === '')
        this.dataForm.arbitre_commissaire_id = this.match.arbitre_commissaire_id
      if(this.dataForm.saison_id === '')
        this.dataForm.saison_id = this.match.saison_id
      if(this.dataForm.championnat_id === '')
        this.dataForm.championnat_id = this.match.championnat_id
      if(this.dataForm.phase === '')
        this.dataForm.phase = this.match.phase
      if(this.dataForm.journee === '')
        this.dataForm.journee = this.match.journee
    },
    setDefaultValues() {
      const match = Object.assign({}, this.match);
      this.dataForm.match_id = match.match_id
      this.dataForm.equipe_a_id = match.equipe_a_id
      this.dataForm.equipe_b_id = match.equipe_b_id
      this.dataForm.date_rencontre = match.date_rencontre
      this.dataForm.temps_rencontre = match.temps_rencontre
      this.dataForm.terrain_id = match.terrain_id
      this.dataForm.arbitre_principal_id = match.arbitre_principal_id
      this.dataForm.arbitre_assistant_1_id = match.arbitre_assistant_1_id
      this.dataForm.arbitre_assistant_2_id = match.arbitre_assistant_2_id
      this.dataForm.arbitre_commissaire_id = match.arbitre_commissaire_id
      this.dataForm.saison_id = match.saison_id
      this.dataForm.championnat_id = match.championnat_id
      this.dataForm.phase = match.phase
      this.dataForm.journee = match.journee
    }
},
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'terrains'
    })
        .then((data) => {
          this.terrains = data.data
        })
        .catch((data) => {
          this.terrains = data
        })
    //
    this.axiosGetAllData({
      table: 'arbitres'
    })
        .then((data) => {
          this.arbitres = data.data
          this.arbitre_principal = this.arbitres.filter((arbitre_principal) => arbitre_principal.arbitre_id === this.match.arbitre_principal_id)[0]
          this.arbitre_assistant_1 = this.arbitres.filter((arbitre_assistant_1) => arbitre_assistant_1.arbitre_id === this.match.arbitre_assistant_1_id)[0]
          this.arbitre_assistant_2 = this.arbitres.filter((arbitre_assistant_2) => arbitre_assistant_2.arbitre_id === this.match.arbitre_assistant_2_id)[0]
          this.arbitre_commissaire = this.arbitres.filter((arbitre_commissaire) => arbitre_commissaire.arbitre_id === this.match.arbitre_commissaire_id)[0]
        })
        .catch((error) => {
          console.log(error)
        })
    //saisons
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //championnats
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > span, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > span.customized-span {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/matchs/components/Update.vue